export default "__VITE_ASSET__fd9cf634__"